import React, { useEffect, useState } from 'react'

import { Modal, Button } from '@/components'
import { isCordovaApp } from '@/helpers'
import { useCheckAppVersion } from '@/hooks/use-check-app-version'
import type { T_UpdateResponse } from '@/hooks/use-check-app-version'


export const CordovaUpdatePrompt: React.FC = () => {
  const [ updateInfo, setUpdateInfo ] = useState<T_UpdateResponse | null>(null)
  const [ isModalOpen, setIsModalOpen ] = useState(false)
  const { checkUpdate } = useCheckAppVersion()

  useEffect(() => {
    // Only run in Cordova environment
    if (!isCordovaApp) return

    const runCheck = async () => {
      try {
        const data = await checkUpdate()
        if (data?.hasUpdate) {
          setUpdateInfo(data)
          setIsModalOpen(true)
        }
      } catch (error) {
        console.error('Failed to check for updates', error)
      }
    }

    runCheck()
  }, [])

  if (!updateInfo) return null

  const handleUpdate = () => {
    if (updateInfo.downloadUrl) {
      // Open in system browser
      const fullUrl = updateInfo.downloadUrl.startsWith('http')
        ? updateInfo.downloadUrl
        : updateInfo.downloadUrl // AUX_API_URL removed

      // Try explicit Cordova InAppBrowser first
      // @ts-expect-error cordova global
      if (typeof cordova !== 'undefined' && cordova.InAppBrowser) {
        // @ts-expect-error cordova global
        cordova.InAppBrowser.open(fullUrl, '_system')
      } else {
        window.open(fullUrl, '_system')
      }
    }

    // Close only if not mandatory
    if (!updateInfo.isMandatory) {
      setIsModalOpen(false)
    }
  }


  return (
    <Modal
      open={isModalOpen}
      onCancel={() => !updateInfo.isMandatory && setIsModalOpen(false)}
      footer={null}
      closable={!updateInfo.isMandatory}
      title='Доступно обновление'
      centered
      maskClosable={!updateInfo.isMandatory}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div>
          <p style={{ fontWeight: 500, marginBottom: 8 }}>
            Доступна новая версия: {updateInfo.latestVersion}
          </p>

          {updateInfo.description && (
            <p style={{ color: 'rgba(0,0,0,0.6)' }}>
              {updateInfo.description}
            </p>
          )}

          {updateInfo.isMandatory && (
            <p style={{ color: '#ff4d4f', marginTop: 8 }}>
              Это обязательное обновление. Вы должны обновить приложение для продолжения работы.
            </p>
          )}
        </div>

        <div style={{ display: 'flex', gap: '8px', flexDirection: 'column' }}>
          <Button onClick={handleUpdate} type='primary' block size='large'>
            Скачать обновление
          </Button>

          {!updateInfo.isMandatory && (
            <Button onClick={() => setIsModalOpen(false)} block>
              Напомнить позже
            </Button>
          )}
        </div>
      </div>
    </Modal>
  )
}
